import React, { useState, useEffect } from 'react';
import HomeTopBar from './HomeTopBar'; 
import GenderBarChart from '../charts/Demographics/GenderBarChart';
import RaceBarChart from '../charts/Demographics/RaceBarChart';
import AgeBarChart from '../charts/Demographics/AgeBarChart';
import WorkingStatus from '../charts/Demographics/WorkingStatus';
import EmploymentStatusChart from '../charts/Demographics/EmploymentStatusChart';
import axios from 'axios';
import { province_market_map, provinces, local_market } from '../constants';
import DemographicsPPTX from '../powerpoint/DemographicsPPTX';

const Demographics = ({ heading, gender, race, age, employment_status, working_status }) => {
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedLocalMarket, setSelectedLocalMarket] = useState(''); 
  const [localMarkets, setLocalMarkets] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [raceData, setRaceData] = useState([]);
  const [ageData, setAgeData] = useState([]);
  const [workingStatusData, setWorkingStatusData] = useState([]);
  const [employmentStatusData, setEmploymentStatusData] = useState([]);

  const handleProvinceChange = (e) => {
    const selectedProvince = e.target.value;
    setSelectedProvince(selectedProvince);
    
    if (selectedProvince && province_market_map[selectedProvince]) {
      setLocalMarkets(province_market_map[selectedProvince].local_markets);
    } else {
      setLocalMarkets([]); 
    }
    setSelectedLocalMarket(''); 
  };

  const getProvinceValue = () => {
    return selectedProvince ? provinces[selectedProvince] : ''; 
  };

  const getLocalMarketValue = () => {
    return selectedLocalMarket ? local_market[selectedLocalMarket] : ''; 
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const provinceValue = getProvinceValue(); 
        const localMarketValue = getLocalMarketValue();         
      
        const genderResponse = await axios.get('https://outlook.plus94research.co.za/api/demographics/gender/', {
          params: {
            province: provinceValue,
            local_market: localMarketValue,
          }
        });
        setGenderData(genderResponse.data.chart_data);
     
        const raceResponse = await axios.get('https://outlook.plus94research.co.za/api/demographics/race/', {
          params: {
            province: provinceValue,
            local_market: localMarketValue,
          }
        });
        setRaceData(raceResponse.data.chart_data);
     
        const ageResponse = await axios.get('https://outlook.plus94research.co.za/api/demographics/age/', {
          params: {
            province: provinceValue,
            local_market: localMarketValue,
          }
        });
        setAgeData(ageResponse.data.chart_data);
      
        const workingStatusResponse = await axios.get('https://outlook.plus94research.co.za/api/demographics/working-status/', {
          params: {
            province: provinceValue,
            local_market: localMarketValue,
          }
        });
        setWorkingStatusData(workingStatusResponse.data.chart_data);
     
        const employmentStatusResponse = await axios.get('https://outlook.plus94research.co.za/api/demographics/employment-status/', {
          params: {
            province: provinceValue,
            local_market: localMarketValue,
          }
        });
        setEmploymentStatusData(employmentStatusResponse.data.chart_data); 
      } catch (error) {
        console.error('Error fetching demographic data:', error);
      }
    };

    fetchData();
  }, [selectedLocalMarket, selectedProvince]);

  return (
    <div className='home'>
      <HomeTopBar />
      <div className='components'>
        <h1 className='demographics-heading'>{heading}</h1>
      </div>

      <div className='filter'>
        <label htmlFor="province-select">Province: </label>
        <select
          id="province-select"
          value={selectedProvince}
          onChange={handleProvinceChange}
        >
          <option value="">All</option>
          {Object.keys(provinces).map((province) => (
            <option key={province} value={province}>
              {province}
            </option>
          ))}
        </select>
        
        <label htmlFor="local-market-select">Local Market: </label>
        <select
          id="local-market-select"
          value={selectedLocalMarket}
          onChange={(e) => setSelectedLocalMarket(e.target.value)}
          disabled={!selectedProvince || localMarkets.length === 0}
        >
          <option value="">All</option>
          {localMarkets.map((market, index) => (
            <option key={index} value={market}>
              {market}
            </option>
          ))}
        </select>
      </div>

      <div>
        <DemographicsPPTX
          selectedProvince={selectedProvince}
          selectedLocalMarket={selectedLocalMarket}
          genderData={genderData}
          raceData = {raceData}
          ageData = {ageData}
          workingStatusData={workingStatusData}
          employmentStatusData={employmentStatusData}
        />
      </div>

      <div className='chart-container'>
        <div className='gender-div'>
          <h4 className='demographics-sub-heading' style={{ marginBottom: '20px' }}>{gender}</h4>        
          <GenderBarChart 
            selectedProvince={selectedProvince}
            selectedLocalMarket={selectedLocalMarket}
            data={genderData} 
          /> 
        </div> 

        <div className='race-div'>
          <h4 className='demographics-sub-heading' style={{ marginBottom: '20px' }}>{race}</h4>           
          <RaceBarChart 
            selectedProvince={selectedProvince}
            selectedLocalMarket={selectedLocalMarket}
            data={raceData} 
          />
        </div> 

        <div className='age-div'>
          <h4 className='demographics-sub-heading' style={{ marginBottom: '20px' }}>{age}</h4>          
          <AgeBarChart data={ageData} /> 
        </div>                     
      </div>

      <div>
        <h4 className='demographics-sub-heading' style={{ marginBottom: '25px' }}>{working_status}</h4> 
        <WorkingStatus chart_data={workingStatusData} style={{ marginBottom: '55px' }} /> 
      </div>

      <div>
        <h4 className='demographics-sub-heading' style={{ marginBottom: '25px' }}>{employment_status}</h4> 
        <EmploymentStatusChart chartData={employmentStatusData} /> 
      </div>
    </div>
  );
};

export default Demographics;

